import type { SeoMetaImageDto } from '../../api/responses'

/**
 * First of `values` that carries actual text.
 *
 * The CMS stores an untouched SEO field as an empty string rather than as null,
 * so `??` alone would pick `''` over a usable fallback.
 */
export function firstText(
  ...values: (string | null | undefined)[]
): string | undefined {
  return values.find(value => value?.trim())?.trim()
}

/** First of `images` that actually has a source. */
export function firstImage(
  ...images: (SeoMetaImageDto | null | undefined)[]
): SeoMetaImageDto | undefined {
  return images.find(image => firstText(image?.url)) ?? undefined
}
